import { i18n } from "translate/i18n";

export const newUpdateAvailable = i18n.t("messages.newUpdateAvailable");
export const appUpdated = i18n.t("messages.appUpdated");
export const update = i18n.t("messages.update");
